import { usePagination } from 'hooks/use-pagination'
import { ChevronsLeft, ChevronsRight } from 'lucide-react'
import ChevronLeft from 'modules/modular/icons/ChevronLeft'
import ChevronRight from 'modules/modular/icons/ChevronRight'
import { Button, Form, Pagination } from 'react-bootstrap'

export function PaginationControls({
    totalCount,
    page,
    pageSize,
    pageSizeOptions,
    visiblePages,
    onPageChange,
    onPageSizeChange,
}) {
    const {
        hasPreviousPage,
        goPreviousPage,
        hasNextPage,
        goNextPage,
        goFistPage,
        goLastPage,
        ...pagination
    } = usePagination(totalCount, {
        page,
        pageSize,
        visiblePages,
        setPage: onPageChange,
    })

    return (
        <div className='flex items-center gap-4'>
            {pageSizeOptions && (
                <div className='flex items-center gap-2'>
                    <label className='text-sm text-nowrap'>Filas por Página</label>
                    <Form.Select
                        value={pagination.pageSize}
                        onChange={(e) => onPageSizeChange?.(parseInt(e.target.value))}
                        className='w-18'
                        size='sm'
                    >
                        {pageSizeOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </Form.Select>
                </div>
            )}
            <div className='flex items-center gap-2 text-sm text-nowrap'>
                Página
                <Form.Control
                    value={pagination.page}
                    onChange={(e) => {
                        const value = e.target.value
                        if (!value) {
                            onPageChange?.(1)
                        }
                        const parsedValue = Number(e.target.value)
                        if (parsedValue > 0 && parsedValue <= pagination.totalPages) {
                            onPageChange?.(parsedValue)
                        }
                    }}
                    onKeyDown={(e) => {
                        const allowedKeys = [
                            'Backspace',
                            'Delete',
                            'ArrowLeft',
                            'ArrowRight',
                            'Tab',
                        ]
                        if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault()
                        }
                    }}
                    onFocus={(e) => e.target.select()}
                    onPaste={(e) => e.preventDefault()}
                    className='w-10 text-center'
                    size='sm'
                />
                de {pagination.totalPages}
            </div>
            <Pagination className='mb-0 gap-1'>
                <Button
                    variant='outline'
                    size='icon-sm'
                    disabled={pagination.page === 1}
                    onClick={goFistPage}
                >
                    <ChevronsLeft />
                </Button>
                <Button
                    variant='outline'
                    size='icon-sm'
                    disabled={!hasPreviousPage()}
                    onClick={goPreviousPage}
                >
                    <ChevronLeft />
                </Button>
                {pagination.pages.map((page) => (
                    <Button
                        key={page}
                        variant='blue'
                        size='icon-sm'
                        disabled={pagination.page === page}
                        onClick={() => onPageChange?.(page)}
                    >
                        {page}
                    </Button>
                ))}
                <Button
                    variant='outline'
                    size='icon-sm'
                    disabled={!hasNextPage()}
                    onClick={goNextPage}
                >
                    <ChevronRight />
                </Button>
                <Button
                    variant='outline'
                    size='icon-sm'
                    disabled={pagination.page === pagination.totalPages}
                    onClick={goLastPage}
                >
                    <ChevronsRight />
                </Button>
            </Pagination>
        </div>
    )
}
